import '../layout/index';

function importAll(r) {
	r.keys().forEach(r);
}

importAll(require.context('../components', true, /behaviour\.js$/));
importAll(require.context('../components', true, /\.less$/));
